import { handleActions } from 'redux-actions';

export default handleActions(
	{
		RESIZE_WINDOW: (state, action) => ({
			...state,

			width: action.payload.width,
			height: action.payload.height,
		}),

		SCROLL_WINDOW: (state, action) => ({
			...state,

			scrollY: action.payload.scrollY,
		}),

		MATCH_MEDIA: (state, action) => ({
			...state,

			media: action.payload.media,
		}),

		PAGE_LOADING: (state, action) => ({
			...state,
			route: {
				...state.route,
				loading: [...state.route.loading, action.payload.page],
			},
		}),

		PAGE_LOADED: (state, action) => ({
			...state,
			route: {
				...state.route,
				loading: state.route.loading.filter(page => page !== action.payload.page),
			},
		}),

		PAGE_ENTERING: (state, action) => ({
			...state,
			route: {
				...state.route,
				entering: [...state.route.entering, action.payload.page],
			},
		}),

		PAGE_ENTERED: (state, action) => ({
			...state,
			route: {
				...state.route,
				entering: state.route.entering.filter(page => page !== action.payload.page),
			},
		}),

		PAGE_CHANGING: (state, action) => ({
			...state,
			route: {
				...state.route,
				changing: [...state.route.changing, action.payload.page],
			},
		}),

		PAGE_CHANGED: (state, action) => ({
			...state,
			route: {
				...state.route,
				changing: state.route.changing.filter(page => page !== action.payload.page),
			},
		}),

		LOADING_RATIO: (state, action) => ({
			...state,
			route: {
				...state.route,
				ratio: {
					...state.route.ratio,
					[action.payload.page]: action.payload.ratio,
				},
			},
		}),

		LOAD_LIBRARY: (state, action) => ({
			...state,

			lib: {
				...state.lib,
				[action.payload.lib]: true,
			},
		}),

		UPDATE_OFFSET_TOP: (state, action) => ({
			...state,

			markerPosition: {
				...state.markerPosition,
				[action.payload.page]: {
					...state.markerPosition[action.payload.page],
					[action.payload.section]: action.payload.offsetTop,
				},
			},
		}),

		LOAD_CONFIG: (state, action) => ({
			...state,

			cookie: action.payload.cookie,
		}),

		AGREE_COOKIE: state => ({
			...state,

			cookie: { display: false },
		}),
	},
	{
		width: document.documentElement.clientWidth,
		height: document.documentElement.clientHeight,
		scrollY: window.scrollY,
		media: '',

		route: {
			loading: [],
			entering: ['ENTER_APP'],
			changing: [],
			ratio: {
				ENTER_APP: 0,
			},
		},

		lib: {
			googleMap: false,
		},

		markerPosition: {
			home: {
				coLiving: 0,
				housingInfo: 0,
				news: 0,
			},
			sidebar: {
				normal: 0,
			},
			bookingbar: {
				normal: 0,
			},
			apartment: {
				info: 0,
				room: 0,
				roommate: 0,
				recommendation: 0,
			},
			room: {
				info: 0,
				apartment: 0,
				roommate: 0,
				recommendation: 0,
			},
			wishlist: {
				room: 0,
				apartment: 0,
			},
			reservationRecord: {
				incoming: 0,
				history: 0,
			},
			bookingList: {
				active: 0,
				past: 0,
			},
			community: {
				search: 0,
				list: 0,
			},
		},

		cookie: {
			display: true,
		},
	},
);



// WEBPACK FOOTER //
// ./src/reducers/global.js